module.exports = __webpack_public_path__ + "static/media/cotton-dress.04bdf262.jpg";